module.exports = __webpack_public_path__ + "img/pr-2.5d093301.png";